import { Button, Col, Form, Input, Row, Space } from "antd";
import axios from "axios";
import React, { Fragment, createRef, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, CardBody, Container } from "reactstrap";
import { Breadcrumbs, H5 } from "../../../AbstractElements";
import { Cancel } from "../../../Constant";
import { VendorApi } from "../../../api";

const VendorForm = (props) => {
  const formRef = createRef();
  const history = useNavigate();
  const [editId, setEditID] = useState(null);
  const [vendorDetails, setVendorDetails] = useState(null);
  const location = useLocation();
  useEffect(() => {
    if (location.state && location.state.id) {
      setEditID(location.state.id);
      fetchDetails();
    }
  }, [editId]);
  const fetchDetails = () => {
    axios.get(`apiV1/vendor/${editId}/`).then((res) => {
      // console.log(res.data)
      formRef.current.setFieldsValue({
        name: res.data.name,
        vendor_code: res.data.vendor_code ? res.data.vendor_code : "",
        contact: res.data.contact,
        email: res.data.email,
        vendor_type: res.data.vendor_type ? res.data.vendor_type : "",
        contact_person: res.data.contact_person ? res.data.contact_person : "",
        gst: res.data.gst ? res.data.gst : "",
        pan_number: res.data.pan_number ? res.data.pan_number : "",
        bank_account_holder: res.data.bank_account_holder
          ? res.data.bank_account_holder
          : "",
        bank_account_number: res.data.bank_account_number
          ? res.data.bank_account_number
          : "",
        bank_ifsc: res.data.bank_ifsc ? res.data.bank_ifsc : "",
        billing_address: res.data.billing_address
          ? res.data.billing_address
          : "",
      });
    });
  };
  const AddVendor = () => {
    const updatedValues = formRef.current.getFieldsValue();
    if (updatedValues.name && updatedValues.contact && updatedValues.email) {
      const values = new FormData();
      values.append("name", updatedValues.name);
      values.append("vendor_code", updatedValues.vendor_code ?? "");
      values.append("contact", updatedValues.contact);
      values.append("vendor_type", updatedValues.vendor_type);
      values.append("pan_number", updatedValues.pan_number);
      values.append("gst", updatedValues.gst);
      values.append("email", updatedValues.email);
      values.append("contact_person", updatedValues.contact_person);
      values.append("billing_address", updatedValues.billing_address);
      values.append("bank_ifsc", updatedValues.bank_ifsc);
      values.append("bank_account_number", updatedValues.bank_account_number);
      values.append("bank_account_holder", updatedValues.bank_account_holder);
      if (editId) {
        axios
          .put(`${VendorApi}${editId}/`, values)
          .then((res) => {
            toast.success("Vendor Edited Successfully!");
            history(`/app/vendor/vendor-list`);
          })
          .catch((res) => {
            toast.error("Something went wrong!");
          });
      } else {
        axios
          .post(`${VendorApi}`, values)
          .then((res) => {
            toast.success("Vendor Added Successfully!");
            history(`/app/vendor/vendor-list`);
          })
          .catch((res) => {
            toast.error("Something went wrong!");
          });
      }
    } else {
      toast.error("Enter Required Fields");
    }
  };

  return (
    <Fragment>
      <Breadcrumbs
        parent="Vendor"
        title={editId ? "Edit Vendor" : "Add Vendor"}
        mainTitle={editId ? "Edit Vendor" : "Add Vendor"}
      />
      <Container fluid={true}>
        <div>
          <Card>
            <CardBody>
              <Form
                layout="vertical"
                id="vendorForm"
                ref={formRef}
                onFinish={AddVendor}
              >
                <H5>Vendor Details</H5>
                <Row gutter={24}>
                  <Col sm={12}>
                    <Form.Item
                      name={"name"}
                      label="Vendor Name"
                      rules={[
                        {
                          required: true,
                          message: "Vendor Name is required",
                        },
                      ]}
                    >
                      <Input placeholder="Vendor name" />
                    </Form.Item>
                  </Col>
                  <Col sm={12}>
                    <Form.Item name={"vendor_type"} label="Category">
                      <Input placeholder="Vendor Category" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col sm={12}>
                    <Form.Item
                      name={"contact_person"}
                      label="Contact person name"
                    >
                      <Input placeholder="Contact person name" />
                    </Form.Item>
                  </Col>
                  <Col sm={12}>
                    <Form.Item
                      name={"contact"}
                      label="Phone Number"
                      rules={[
                        {
                          required: true,
                          message: "Phone Number is required",
                        },
                      ]}
                    >
                      <Input placeholder="Phone Number" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col sm={12}>
                    <Form.Item
                      name={"email"}
                      label="Email"
                      rules={[{ required: true, message: "Email is required" }]}
                    >
                      <Input placeholder="Email" />
                    </Form.Item>
                  </Col>
                  <Col sm={12}>
                    <Form.Item
                      name={"vendor_code"}
                      label="Vendor Code"
                      rules={[
                        { required: true, message: "Vendor code is required" },
                      ]}
                    >
                      <Input placeholder="Vendor code " />
                    </Form.Item>
                  </Col>
                </Row>
                <H5>Vendor Financial Details</H5>
                <Row gutter={24}>
                  <Col sm={12}>
                    <Form.Item
                      name={"bank_account_number"}
                      label="Bank Account Number"
                    >
                      <Input placeholder="Bank Account Number" />
                    </Form.Item>
                  </Col>
                  <Col sm={12}>
                    <Form.Item
                      name={"bank_account_holder"}
                      label="Bank Holder Name"
                    >
                      <Input placeholder="Bank Holder Name" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col sm={12}>
                    <Form.Item name={"bank_ifsc"} label="IFSC Code">
                      <Input placeholder="IFSC Code" />
                    </Form.Item>
                  </Col>
                  <Col sm={12}>
                    <Form.Item name={"billing_address"} label="Billing Address">
                      <Input placeholder="Billing Address" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col sm={12}>
                    <Form.Item name={"gst"} label="GST Number">
                      <Input placeholder="GST Number" />
                    </Form.Item>
                  </Col>
                  <Col sm={12}>
                    <Form.Item name={"pan_number"} label="PAN Number">
                      <Input placeholder="PAN Number" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col>
                    <Space className="mb-0">
                      <Button htmlType="submit" form="vendorForm">
                        {editId ? "Save Changes" : "Add"}
                      </Button>
                      <Button
                        type="primary"
                        danger
                        htmlType="reset"
                        form="vendorForm"
                      >
                        {Cancel}
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </div>
      </Container>
    </Fragment>
  );
};

export default VendorForm;
